import React, { useEffect, useState } from "react";
import classes from "../../style/Style.module.css";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Toast from "../../Components/ToastMsg/Toast";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import {
  ROUTE_CUSTOMER_SUPPORT_SCREEN,
  ROUTE_Purchase_CONFRIMATION_,
  ROUTE_SIP_Confirmation_Link,
} from "../../Routes";
import { selectPanNumber } from "../../Store/panNumberSlice";
import { selectPhoneNumber } from "../../Store/MobileSlice";
import {
  selectTransactionNumber,
  setTransactionNumber,
} from "../../Store/TransactionNoSlice";
import { selectRefreshToken } from "../../Store/Token/refreshTokenSlice";
import NewDexterLogo from "../../Images/NewDexterLogo.svg";
import { selectIINNumber } from "../../Store/IINSlice";
import "../../style/Purchase.scss"

const PurchaseVerifyOtp = () => {
  const [userOtp, setUserOtp] = useState("");
  const phoneNumber = useSelector(selectPhoneNumber);

  const storedToken = useSelector((state) => state.storedToken.accessToken);
  const panNumber = useSelector(selectPanNumber);
  const iinNumber = useSelector(selectIINNumber);
  const location = useLocation();
  const { UserMobileNumber } = location.state || phoneNumber;
  const [verifyButtonClicked, setVerifyButtonClicked] = useState(false);
  const [verificationError, setVerificationError] = useState(false);
  const [seconds, setSeconds] = useState("");
  const [timerId, setTimerId] = useState(null);
  const Navigate = useNavigate();
  const transactionNumber = useSelector(selectTransactionNumber);
  // const refreshToken = useSelector(selectRefreshToken);
  const [apiCallsInProgress, setApiCallsInProgress] = useState(3);
  const [DataGetDetails, setDataGetDetails] = useState({});
  const dispatch = useDispatch();


  const [isLoading, setIsLoading] = useState(false);
  const [ApiTransaction, setApiTransaction] = useState("");

  useEffect(() => {
    if (apiCallsInProgress > 3) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [apiCallsInProgress]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const GetDetailsResponse = await axios.post(
          "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
          {
            nsePurchaseTrxnGetDetails: {
              dexterr_transaction_no: transactionNumber,
            },
          }
        );
        setDataGetDetails(GetDetailsResponse.data.body);
        dispatch(
          setTransactionNumber(
            GetDetailsResponse.data.body.dexterr_transaction_no
          )
        );
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleInputChange = (e) => {
    const input = e.target.value.replace(/\D/g, "");

    setUserOtp(input);
  };

  // //console.log(mobileOTP,"passed")
  const handleClearButtonClick = () => {
    setUserOtp("");
  };



  const handleResendButtonClick = async () => {
    setSeconds(59);
    if (timerId) {
      clearInterval(timerId);
    }
    const id = setInterval(() => {
      setSeconds((prevSeconds) => {
        if (prevSeconds === 0) {
          clearInterval(id);
          return "";
        }
        return prevSeconds - 1;
      });
    }, 1000);
    setTimerId(id);

    try {
      const axiosConfig = {
        headers: {
          Authorization: `Bearer ${storedToken}`,
          "Content-Type": "application/json",
          // RefreshToken: refreshToken
        },
      };

      const response = await axios.post(
        "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
        {
          OtpVerification: {
            dexterr_transaction_no: transactionNumber,
            mobileNumber: phoneNumber,
            pan: panNumber,
            service: "purchase",
            job: "sendOtp",
          },
        },
        axiosConfig
      );

      //console.log("OTP Resent successfully", response);
    } catch (error) {
      // Handle error (e.g., show error message)
      console.error("Error resending OTP:", error);
    }
  };

  const handleSubmit = async () => {
    if (userOtp.length !== 6) {
      Toast.error("Please enter a 6-digit OTP.");
      return;
    }

    try {
      setApiCallsInProgress(apiCallsInProgress + 1);
      const response = await axios.post(
        "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
        {
          OtpVerification: {
            dexterr_transaction_no: transactionNumber,
            mobileNumber: phoneNumber,
            pan: panNumber,
            service: "purchase",
            job: "verifyOtp",
            otp: userOtp,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      //console.log(response.data);
      //console.log(response);
      // //console.log(DataGetDetails)
      if (
        response.status === 200 &&
        response.data.statusCode === 200 &&
        response.data.message === "Successful."
      ) {
        //console.log(response.data.message);
        if (DataGetDetails && DataGetDetails.purchase_type) {
          const purchaseType = DataGetDetails.purchase_type;
          //if both purchase types is there then
          if (
            purchaseType.includes("One Time") &&
            purchaseType.includes("Systematic")
          ) {
            const paymentGatewayResponse = await axios.post(
              "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
              {
                nseOneTimePurchaseTrxn: {
                  dexterr_transaction_no: transactionNumber,
                },
              },
              {
                headers: {
                  Authorization: `Bearer ${storedToken}`,
                  "Content-Type": "application/json",
                },
              }
            );

            setApiTransaction(
              paymentGatewayResponse.data.body.dexterr_transaction_no
            );

            if (
              paymentGatewayResponse.data.status === true &&
              paymentGatewayResponse.data.statusCode === 200
            ) {
              const {
                fund_details,
                total_onetime_purchase_amount,
                total_sip_purchase_amount,
                pan,
                sheet_iin,
                input_ref_no,
                sheet_iin_activation_status,
                purchase_trxn_input_list,
                sheet_primary_distributor,
              } = paymentGatewayResponse.data.body;
              const nseOneTimeSendNSe = await axios.post(
                "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",

                {
                  nseOneTimePurchaseTrxnSendNse: {
                    dexterr_transaction_no:
                      transactionNumber ||
                      paymentGatewayResponse.data.body.dexterr_transaction_no,
                    fund_details: fund_details,
                    total_onetime_purchase_amount:
                      total_onetime_purchase_amount,
                    total_sip_purchase_amount: total_sip_purchase_amount,
                    pan: pan,
                    sheet_iin: sheet_iin,
                    input_ref_no: input_ref_no,
                    sheet_iin_activation_status: sheet_iin_activation_status,
                    purchase_trxn_input_list: purchase_trxn_input_list,
                    sheet_primary_distributor: sheet_primary_distributor,
                  },
                },
                {
                  headers: {
                    Authorization: `Bearer ${storedToken}`,
                    "Content-Type": "application/json",
                  },
                }
              );

              if (
                (nseOneTimeSendNSe.data.status === "True" &&
                  nseOneTimeSendNSe.data.statusCode === 200 &&
                  nseOneTimeSendNSe.data.body.payment_link !== "") ||
                nseOneTimeSendNSe.data.body.payment_link !== null
              ) {
                const paymentLink = nseOneTimeSendNSe.data.body.payment_link;
                const {
                  payment_link,
                  purchase_trxn_dexterr_reference_unique_no,
                  total_sip_purchase_amount,
                  input_ref_no,
                  purchase_trxn_api_service_response,
                  purchase_trxn_api_error,
                  iin,
                  iin_activation_status,
                  primary_distributor,
                  purchase_trxn_input_list,
                  purchase_req_xml,
                  purchase_trxn_api_xml_data_dict,
                  purchase_trxn_api_xml_json_data,
                } = nseOneTimeSendNSe.data.body;

                if (paymentLink && paymentLink.trim() !== "") {
                  try {
                  const nseOneTimeTrxnWrite = await axios.post(
                    "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",

                    {
                      nseOneTimePurchaseTrxnWrite: {
                        dexterr_transaction_no:
                          transactionNumber ||
                          paymentGatewayResponse.data.body
                            .dexterr_transaction_no,
                        payment_link: payment_link,
                        purchase_trxn_dexterr_reference_unique_no:
                          purchase_trxn_dexterr_reference_unique_no,
                        total_sip_purchase_amount: total_sip_purchase_amount,
                        input_ref_no: input_ref_no,
                        purchase_trxn_api_service_response:
                          purchase_trxn_api_service_response,
                        purchase_trxn_api_error: purchase_trxn_api_error,
                        iin: iin,
                        iin_activation_status: iin_activation_status,
                        primary_distributor: primary_distributor,
                        purchase_trxn_input_list: purchase_trxn_input_list,
                        purchase_req_xml: purchase_req_xml,
                        purchase_trxn_api_xml_data_dict:
                          purchase_trxn_api_xml_data_dict,
                        purchase_trxn_api_xml_json_data:
                          purchase_trxn_api_xml_json_data,
                      },
                    },
                    {
                      headers: {
                        Authorization: `Bearer ${storedToken}`,
                        "Content-Type": "application/json",
                      },
                    }
                  );

                  // const DexPrchsTrxnUpdateDetails = await axios.post(
                  //   "https://partnerapp.ambrela.money/api/DexterrPurchaseTransactionUpdateDetails",

                  //   {
                  //     dexterr_transaction_no: transactionNumber || paymentGatewayResponse.data.body.dexterr_transaction_no,
                  //     onetime_purchase_nse_unique_no: purchase_trxn_dexterr_reference_unique_no,
                  //     ach_emandate_reg_nse_unique_no: "",
                  //     sip_purchase_nse_unique_no: ""
                  //   },
                  //   {
                  //     headers: {
                  //       Authorization: `Bearer ${storedToken}`,
                  //       "Content-Type": "application/json",
                  //     },
                  //   }
                  // )
                  // if (DexPrchsTrxnUpdateDetails.data.statusCode === 200) {



                  if (nseOneTimeTrxnWrite.statusCode) {
                    setApiCallsInProgress(apiCallsInProgress - 1);
                  }
                } catch (error) {
                  // Log the error but proceed with redirection
                  console.error("Error in the write API:", error);
                } finally {
                  // Always redirect to the payment link regardless of the write API result
                  window.location.href = paymentLink;
                }

                  // }
                  // else {
                  //   Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                  //     state: {
                  //       reason: "Your One Time Purchase Transaction Failed.",
                  //     },
                  //   });
                  // }
                }

                else {
                  Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                    state: {
                      reason: "Your One Time Purchase Transaction Failed.",
                    },
                  });
                }
              } else {
                // TrxnGetDetailsData();
                setApiCallsInProgress(apiCallsInProgress - 1);

                Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                  state: {
                    reason: nseOneTimeSendNSe.data.errorMessage,
                  },
                });
              }
            } else {
              setApiCallsInProgress(apiCallsInProgress - 1);

              Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                state: { reason: paymentGatewayResponse.data.errorMessage },
              });
            }
          } else if (purchaseType.includes("One Time")) {
            // Call nseOneTimePurchaseTrxn API
            const paymentGatewayResponse = await axios.post(
              "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
              {
                nseOneTimePurchaseTrxn: {
                  dexterr_transaction_no: transactionNumber,
                },
              },
              {
                headers: {
                  Authorization: `Bearer ${storedToken}`,
                  "Content-Type": "application/json",
                },
              }
            );
            const {
              fund_details,
              total_onetime_purchase_amount,
              total_sip_purchase_amount,
              pan,
              sheet_iin,
              input_ref_no,
              sheet_iin_activation_status,
              purchase_trxn_input_list,
              sheet_primary_distributor,
            } = paymentGatewayResponse.data.body;
            console.log(paymentGatewayResponse.data.body);
            console.log(fund_details);

            if (
              paymentGatewayResponse.data.status === true &&
              paymentGatewayResponse.data.statusCode === 200
            ) {
              const nseOneTimeSendNSe = await axios.post(
                "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",

                {
                  nseOneTimePurchaseTrxnSendNse: {
                    dexterr_transaction_no:
                      transactionNumber ||
                      paymentGatewayResponse.data.body.dexterr_transaction_no,
                    fund_details: fund_details,
                    total_onetime_purchase_amount:
                      total_onetime_purchase_amount,
                    total_sip_purchase_amount: total_sip_purchase_amount,
                    pan: pan,
                    sheet_iin: sheet_iin,
                    input_ref_no: input_ref_no,
                    sheet_iin_activation_status: sheet_iin_activation_status,
                    purchase_trxn_input_list: purchase_trxn_input_list,
                    sheet_primary_distributor: sheet_primary_distributor,
                  },
                },
                {
                  headers: {
                    Authorization: `Bearer ${storedToken}`,
                    "Content-Type": "application/json",
                  },
                }
              );
              if (
                (nseOneTimeSendNSe.data.status === "True" &&
                  nseOneTimeSendNSe.data.statusCode === 200 &&
                  nseOneTimeSendNSe.data.body.payment_link !== "") ||
                nseOneTimeSendNSe.data.body.payment_link !== null
              ) {
                const paymentLink = nseOneTimeSendNSe.data.body.payment_link;

                const {
                  payment_link,
                  purchase_trxn_dexterr_reference_unique_no,
                  total_sip_purchase_amount,
                  input_ref_no,
                  purchase_trxn_api_service_response,
                  purchase_trxn_api_error,
                  iin,
                  iin_activation_status,
                  primary_distributor,
                  purchase_trxn_input_list,
                  purchase_req_xml,
                  purchase_trxn_api_xml_data_dict,
                  purchase_trxn_api_xml_json_data,
                } = nseOneTimeSendNSe.data.body;

                if (paymentLink && paymentLink.trim() !== "") {
                  try {
                  setApiCallsInProgress(apiCallsInProgress - 1);

                  const nseOneTimeTrxnWrite = await axios.post(
                    "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",

                    {
                      nseOneTimePurchaseTrxnWrite: {
                        dexterr_transaction_no:
                          transactionNumber ||
                          paymentGatewayResponse.data.body
                            .dexterr_transaction_no,
                        payment_link: payment_link,
                        purchase_trxn_dexterr_reference_unique_no:
                          purchase_trxn_dexterr_reference_unique_no,
                        total_sip_purchase_amount: total_sip_purchase_amount,
                        input_ref_no: input_ref_no,
                        purchase_trxn_api_service_response:
                          purchase_trxn_api_service_response,
                        purchase_trxn_api_error: purchase_trxn_api_error,
                        iin: iin,
                        iin_activation_status: iin_activation_status,
                        primary_distributor: primary_distributor,
                        purchase_trxn_input_list: purchase_trxn_input_list,
                        purchase_req_xml: purchase_req_xml,
                        purchase_trxn_api_xml_data_dict:
                          purchase_trxn_api_xml_data_dict,
                        purchase_trxn_api_xml_json_data:
                          purchase_trxn_api_xml_json_data,
                      },
                    },
                    {
                      headers: {
                        Authorization: `Bearer ${storedToken}`,
                        "Content-Type": "application/json",
                      },
                    }
                  );
                  // const DexPrchsTrxnUpdateDetails = await axios.post(
                  //   "https://partnerapp.ambrela.money/api/DexterrPurchaseTransactionUpdateDetails",

                  //   {
                  //     dexterr_transaction_no: transactionNumber || paymentGatewayResponse.data.body.dexterr_transaction_no,
                  //     onetime_purchase_nse_unique_no: purchase_trxn_dexterr_reference_unique_no,
                  //     ach_emandate_reg_nse_unique_no: "",
                  //     sip_purchase_nse_unique_no: ""
                  //   },
                  //   {
                  //     headers: {
                  //       Authorization: `Bearer ${storedToken}`,
                  //       "Content-Type": "application/json",
                  //     },
                  //   }
                  // )
                  // if (DexPrchsTrxnUpdateDetails.data.statusCode === 200) {

                  if (nseOneTimeTrxnWrite.statusCode) {
                    setApiCallsInProgress(apiCallsInProgress - 1);
                  }
                } catch (error) {
                  // Log the error but proceed with redirection
                  console.error("Error in the write API:", error);
                } finally {
                  // Always redirect to the payment link regardless of the write API result
                  window.location.href = paymentLink;
                }
                  // window.location.href = paymentLink;

                  // }
                  // else {
                  //   Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                  //     state: {
                  //       reason: "Your One Time Purchase Transaction Failed.",
                  //     },
                  //   });
                  // }
                } else {
                  Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                    state: {
                      reason: "Your One Time Purchase Transaction Failed.",
                    },
                  });
                }
              } else {
                // TrxnGetDetailsData();
                setApiCallsInProgress(apiCallsInProgress - 1);

                Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                  state: {
                    reason: nseOneTimeSendNSe.data.errorMessage,
                  },
                });
              }
            } else {
              Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                state: { reason: paymentGatewayResponse.data.errorMessage },
              });
            }
          } else if (purchaseType.includes("Systematic")) {
            // Call nseGetUmrn API
            const umrnResponse = await axios.post(
              "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
              {
                nseGetUmrn: {
                  iin: iinNumber,
                },
              },
              {
                headers: {
                  Authorization: `Bearer ${storedToken}`,
                  "Content-Type": "application/json",
                },
              }
            );

            console.log(umrnResponse.data.body.umrn);
            if (
              (umrnResponse.data &&
                umrnResponse.data.statusCode === 200 &&
                umrnResponse.data.body &&
                umrnResponse.data.body.umrn !== "")
              // umrnResponse.data.body.umrn !== null
            ) {
              // Call nseSipRegistration API
              const sipRegistrationResponse = await axios.post(
                "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
                {
                  nseSipRegistration: {
                    dexterr_transaction_no: transactionNumber,
                    umrn_no: umrnResponse.data.body.umrn,
                  },
                },
                {
                  headers: {
                    Authorization: `Bearer ${storedToken}`,
                    "Content-Type": "application/json",
                  },
                }
              );

              if (
                sipRegistrationResponse.data.statusCode === 200 &&
                sipRegistrationResponse.data.status === true
              ) {
                const {
                  fund_details,
                  total_onetime_purchase_amount,
                  total_sip_purchase_amount,
                  pan,
                  sheet_iin,

                  sheet_iin_activation_status,
                  purchase_trxn_input_list,
                  sheet_primary_distributor,
                } = sipRegistrationResponse.data.body;
                const sipnseOneTimeSendNSe = await axios.post(
                  "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",

                  {
                    nseSipRegistrationSendNse: {
                      dexterr_transaction_no:
                        transactionNumber || ApiTransaction,
                      fund_details: fund_details,
                      total_onetime_purchase_amount:
                        total_onetime_purchase_amount,
                      total_sip_purchase_amount: total_sip_purchase_amount,
                      pan: pan,
                      sheet_iin: sheet_iin,
                      input_ref_no:
                        sipRegistrationResponse.data.body.input_ref_no,
                      umrn_no: sipRegistrationResponse.data.body.umrn_no,
                      sheet_iin_activation_status: sheet_iin_activation_status,
                      purchase_trxn_input_list: purchase_trxn_input_list,
                      sheet_primary_distributor: sheet_primary_distributor,
                    },
                  },
                  {
                    headers: {
                      Authorization: `Bearer ${storedToken}`,
                      "Content-Type": "application/json",
                    },
                  }
                );

                if (
                  sipnseOneTimeSendNSe.data.status === true &&
                  sipnseOneTimeSendNSe.data.statusCode === 200 &&
                  sipnseOneTimeSendNSe.data.body
                    .purchase_trxn_dexterr_reference_unique_no !== "" &&
                  sipnseOneTimeSendNSe.data.body.service_msg === "Success" &&
                  sipnseOneTimeSendNSe.data.body.status === "Success"
                ) {
                  const {
                    status,
                    input_ref_no,
                    umrn_no,
                    purchase_trxn_dexterr_reference_unique_no,
                    dexterr_transaction_no,
                    sip_from_date,
                    sip_to_date,
                    sip_period_day,
                    ach_amt,
                    ach_fromdate,
                    ach_enddate,
                    service_return_msg,
                    service_return_code,
                    service_msg,
                    service_response,
                    iin,
                    iin_activation_status,
                    primary_distributor,
                    purchase_trxn_list,
                    purchase_trxn_api_xml_json_data,
                    purchase_trxn_api_xml_data_dict,
                    purchase_req_xml,
                  } = sipnseOneTimeSendNSe.data.body;
                  try {
                    setApiCallsInProgress(apiCallsInProgress + 1);

                    const nseSipRegistrationWriteresponse = await axios.post(
                      "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",

                      {
                        nseSipRegistrationWrite: {
                          status: status,
                          input_ref_no: input_ref_no,
                          umrn_no: umrn_no,
                          purchase_trxn_dexterr_reference_unique_no:
                            purchase_trxn_dexterr_reference_unique_no,
                          dexterr_transaction_no:
                            dexterr_transaction_no || ApiTransaction,
                          sip_from_date: sip_from_date,
                          sip_to_date: sip_to_date,
                          sip_period_day: sip_period_day,
                          ach_amt: ach_amt,
                          ach_fromdate: ach_fromdate,
                          ach_enddate: ach_enddate,
                          service_return_msg: service_return_msg,
                          service_return_code: service_return_code,
                          service_msg: service_msg,
                          service_response: service_response,
                          iin: iin,
                          iin_activation_status: iin_activation_status,
                          primary_distributor: primary_distributor,
                          purchase_trxn_list: purchase_trxn_list,
                          purchase_trxn_api_xml_json_data:
                            purchase_trxn_api_xml_json_data,
                          purchase_trxn_api_xml_data_dict:
                            purchase_trxn_api_xml_data_dict,
                          purchase_req_xml: purchase_req_xml,
                        },
                      },
                      {
                        headers: {
                          Authorization: `Bearer ${storedToken}`,
                          "Content-Type": "application/json",
                        },
                      }
                    );
                    console.log(nseSipRegistrationWriteresponse.status);
                    console.log(nseSipRegistrationWriteresponse.data.status);
                    console.log(nseSipRegistrationWriteresponse.message);
                    console.log(nseSipRegistrationWriteresponse)

                    // const DexPrchsTrxnUpdateDetails = await axios.post(
                    //   "https://partnerapp.ambrela.money/api/DexterrPurchaseTransactionUpdateDetails",

                    //   {
                    //     dexterr_transaction_no: transactionNumber || ApiTransaction,
                    //     onetime_purchase_nse_unique_no: "",
                    //     ach_emandate_reg_nse_unique_no: "",
                    //     sip_purchase_nse_unique_no: purchase_trxn_dexterr_reference_unique_no
                    //   },
                    //   {
                    //     headers: {
                    //       Authorization: `Bearer ${storedToken}`,
                    //       "Content-Type": "application/json",
                    //     },
                    //   }
                    // )



                    // if(nseSipRegistrationWriteresponse.statusCode !== 200 || nseSipRegistrationWriteresponse.statusCode === 200 || nseSipRegistrationWriteresponse.message === "Endpoint request timed out" )
                    Navigate(ROUTE_SIP_Confirmation_Link);
                    setApiCallsInProgress(apiCallsInProgress - 1);


                    // Navigate(ROUTE_SIP_Confirmation_Link);
                    setApiCallsInProgress(apiCallsInProgress - 1);
                  }
                  catch (error) {
                    setApiCallsInProgress(apiCallsInProgress - 1);

                    // If there's an error with the API call, also navigate to ROUTE_SIP_Confirmation_Link
                    Navigate(ROUTE_SIP_Confirmation_Link);
                  }
                }

                else {
                  setApiCallsInProgress(apiCallsInProgress - 1);

                  Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                    state: { reason: sipnseOneTimeSendNSe.data.errorMessage || "Your SIP Transaction Failed" },
                  });
                }

                // Navigate(ROUTE_SIP_Confirmation_Link);
              } else if (
                sipRegistrationResponse.statusCode === 504 ||
                sipRegistrationResponse.message === "Endpoint request timed out"
              ) {
                setApiCallsInProgress(apiCallsInProgress - 1);

                console.log("Endpoint request timed out aip api");
                Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                  state: {
                    reason:
                      sipRegistrationResponse.data.errorMessage ||
                      "Your SIP Transaction Failed",
                  },
                });
              } else {
                Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                  state: {
                    reason:
                      sipRegistrationResponse.data.errorMessage ||
                      "Your SIP Transaction Failed",
                  },
                });
              }
            }

            else if (
              umrnResponse.data.body.umrn === ""
              // umrnResponse.data.body.umrn === null
            ) {
              // Call nseAchEmandateRegistration API

              const achEmandateResponse = await axios.post(
                "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
                {
                  nseAchEmandateRegistration: {
                    dexterr_transaction_no: transactionNumber,
                  },
                },
                {
                  headers: {
                    Authorization: `Bearer ${storedToken}`,
                    "Content-Type": "application/json",
                  },
                }
              );
              if (
                achEmandateResponse.data.status === true &&
                achEmandateResponse.data.statusCode === 200
              ) {
                const {
                  fund_details,
                  total_onetime_purchase_amount,
                  total_sip_purchase_amount,
                  pan,
                  sheet_iin,
                  input_ref_no,
                  sheet_iin_activation_status,
                  purchase_trxn_input_list,
                  sheet_primary_distributor,
                } = achEmandateResponse.data.body;
                const nseAchEmandateRegistrationSendNseresponse =
                  await axios.post(
                    "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
                    {
                      nseAchEmandateRegistrationSendNse: {
                        dexterr_transaction_no: transactionNumber,
                        fund_details: fund_details,
                        total_onetime_purchase_amount:
                          total_onetime_purchase_amount,
                        total_sip_purchase_amount: total_sip_purchase_amount,
                        pan: pan,
                        sheet_iin: sheet_iin,
                        input_ref_no: input_ref_no,
                        sheet_iin_activation_status:
                          sheet_iin_activation_status,
                        purchase_trxn_input_list: purchase_trxn_input_list,
                        sheet_primary_distributor: sheet_primary_distributor,
                      },
                    }
                  );
                if (
                  nseAchEmandateRegistrationSendNseresponse.data.status ===
                  true &&
                  nseAchEmandateRegistrationSendNseresponse.data.statusCode ===
                  200
                ) {
                  const {
                    ach_emandate_link,
                    ach_emandate_registration_unique_no,
                    ach_emandate_registration_service_status,
                    ach_emandate_registration_xml_payload,
                    ach_emandate_registration_xml_data,
                    ach_emandate_registration_json_data,
                    ach_emandate_registration_service_response,
                    ach_emandate_reg_service_response_return_msg,
                    iin,
                    pan,
                    iin_activation_status,
                    primary_distributor,
                    purchase_trxn_input_list,
                  } = nseAchEmandateRegistrationSendNseresponse.data.body;

                  try {
                    const nseAchEmandateRegistrationWriteresponse =
                      await axios.post(
                        "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
                        {
                          nseAchEmandateRegistrationWrite: {
                            dexterr_transaction_no: transactionNumber,
                            ach_emandate_link: ach_emandate_link,
                            ach_emandate_registration_unique_no:
                              ach_emandate_registration_unique_no,
                            ach_emandate_registration_service_status:
                              ach_emandate_registration_service_status,
                            ach_emandate_registration_xml_payload:
                              ach_emandate_registration_xml_payload,
                            ach_emandate_registration_xml_data:
                              ach_emandate_registration_xml_data,
                            ach_emandate_registration_json_data:
                              ach_emandate_registration_json_data,
                            ach_emandate_registration_service_response:
                              ach_emandate_registration_service_response,
                            ach_emandate_reg_service_response_return_msg:
                              ach_emandate_reg_service_response_return_msg,
                            iin: iin,
                            pan: pan,
                            iin_activation_status: iin_activation_status,
                            primary_distributor: primary_distributor,
                            purchase_trxn_input_list: purchase_trxn_input_list,
                          },
                        }
                      );

                    const achEmandateLink = ach_emandate_link;
                    if (achEmandateLink && achEmandateLink.trim() !== "") {
                      window.location.href = achEmandateLink;
                    }
                    else {
                      Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                        state: { reason: "ACH EMandate for SIP Failed." },
                      });
                    }
                  }
                  catch {

                    const achEmandateLink = ach_emandate_link;

                    if (achEmandateLink && achEmandateLink.trim() !== "") {
                      window.location.href = achEmandateLink;
                    }
                    else {
                      Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                        state: { reason: "ACH EMandate for SIP Failed." },
                      });
                    }
                  }
                  // }

                  // else {
                  //   Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                  //     state: { reason: "ACH EMandate for SIP Failed." },
                  //   });
                  // }
                }
                else {
                  if (nseAchEmandateRegistrationSendNseresponse.data.status ===
                    false &&
                    nseAchEmandateRegistrationSendNseresponse.data.statusCode ===
                    500 &&
                    nseAchEmandateRegistrationSendNseresponse.data.errorMessage === "REGISTRATION IS ALREADY AVAILABLE WITH THE GIVEN MANDATE. | Failed To ACH Registration Inserted") {
  
                    const headers = {
                      Authorization: `Bearer ${storedToken}`,
                      // RefreshToken: refreshToken
                    };
                    const AchRetriggerResponse = await axios.post(
                      "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
                      {
                        nseAchEmandateRegistrationRetrigger: {
                          iin: iinNumber,
                          dexterr_transaction_no: transactionNumber,
                        },
                      },
                      {
                        headers: {
                          Authorization: `Bearer ${storedToken}`,
                          // RefreshToken: refreshToken
                        },
                      }
                    );
  
                    if (AchRetriggerResponse.data.status === "true" && AchRetriggerResponse.data.message === "Successful")
                    {
                      const achEmandateLink = AchRetriggerResponse.data.body.ach_emandate_link;
                      if (achEmandateLink && achEmandateLink.trim() !== "") {
                        window.location.href = achEmandateLink;
                      }
                      else {
                        Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                          state: { reason: nseAchEmandateRegistrationSendNseresponse.data.errorMessage || AchRetriggerResponse.data.errorMessage },
                        });
                      }
                    }
                    else {
                      {
                        Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                          state: { reason: nseAchEmandateRegistrationSendNseresponse.data.errorMessage ||  AchRetriggerResponse.data.errorMessage },
                        });
                      }
                    }
  
  
                  }
                }

                // else {
                //   if (
                //     nseAchEmandateRegistrationSendNseresponse.data.status !==
                //     true ||
                //     nseAchEmandateRegistrationSendNseresponse.data.body
                //       .ach_emandate_link === ""
                //   ) {
                //     Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                //       state: { reason: nseAchEmandateRegistrationSendNseresponse.data.errorMessage || "ACH EMandate for SIP Failed." },
                //     });
                //   } else {
                //     Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                //       state: { reason: nseAchEmandateRegistrationSendNseresponse.data.errorMessage || "ACH EMandate for SIP Failed." },
                //     });
                //   }
                // }

              }
             

              // else {
              //   Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
              //     state: { reason: achEmandateResponse.data.errorMessage },
              //   });
              // }
            } else {
              setApiCallsInProgress(apiCallsInProgress - 1);

              Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                state: { reason: "Your SIP Transaction Failed" },
              });
            }
          }
        }
      } else {
        Toast.error(
          response.data.errorMessage || response.data.message || "Error"
        );
        setVerificationError(true);
        setApiCallsInProgress(apiCallsInProgress - 1);
      }
      // setApiCallsInProgress(apiCallsInProgress - 1);
    } catch (error) {
      setApiCallsInProgress(apiCallsInProgress - 1);

      console.error("Error making API call:", error);
      // if (
      //   error.response &&
      //   (error.response.status === 504 ||
      //     error.response.message === "Endpoint request timed out")
      // ) {
      //   const timeoutResponse = await axios.post(
      //     "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
      //     {
      //       nsePurchaseTrxnGetDetails: {
      //         dexterr_transaction_no: transactionNumber,
      //         onetime_purchase_input_ref_no: "",
      //         ach_emandate_registration_unique_no: "",
      //         sip_purchase_input_ref_no: "",
      //       },
      //     },
      //     {
      //       headers: {
      //         Authorization: `Bearer ${storedToken}`,
      //         "Content-Type": "application/json",
      //       },
      //     }
      //   );

      //   if (
      //     (timeoutResponse.status === 200 &&
      //       timeoutResponse.data.body &&
      //       timeoutResponse.data.body.one_time_purchase_payment_link !== "") ||
      //     timeoutResponse.data.body.one_time_purchase_payment_link !== null
      //   ) {
      //     const paymentLink =
      //       timeoutResponse.data.body.one_time_purchase_payment_link;
      //     //console.log(paymentLink, "payment link");
      //     if (paymentLink && paymentLink.trim() !== "") {
      //       // window.open(paymentLink, "_blank");
      //       window.location.href = paymentLink;

      //       //console.log("this condition is working");
      //     } else {
      //       // Toast.error("Payment link not available.");
      //       console.log("one time api 1");

      //       Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
      //         state: { reason: "Your Purchase Transaction Failed." },
      //       });
      //     }
      //   } else {
      //     // Toast.error("Payment Failed");
      //     console.log(" one time api 2");

      //     Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
      //       state: { reason: "Your Purchase Transaction Failed." },
      //     });
      //   }
      //   Toast.error(
      //     error.response.errorMessage || error.response.message || "Error"
      //   );
      // } 
      if (
        error.response &&
        (error.response.status === 504 ||
          error.response.message === "Endpoint request timed out")
      ) {
        Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
          state: { reason: "Your Purchase Transaction Failed." },
        });
      } else {
        Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
          state: { reason: "Your Purchase Transaction Failed." },
        });
      }
    }








  };

  const HandleBack = () => {
    Navigate(-1);
  };
  return (
    <div className="Mobile_Main_Container">
      <div className="Purchase_VrifyOtp_Header">
        <ArrowBackIosIcon className="Back_btn" onClick={HandleBack} />
        <div className="Dexter_logo_container">
          <img alt="" src={NewDexterLogo} className="DexterLogo" />
        </div>
      </div>
      <div className="Confirmation_Input_Container">
        <p className="Input_Heading_text">Confirm your Transaction</p>
        <span className="Input_Sub_heading">
          Please enter the 6 digit code sent to your Mobile Number
        </span>
        <div className="Input_Filed_Box">
          <span className="Enter_mobile_text">Enter OTP</span>
          <div className="Input_Inner_Container">
            <input
              className={classes.Input_Filed}
              value={userOtp}
              onChange={handleInputChange}
              maxLength={6}
            />
            <button
              className="Cross_button"
              onClick={handleClearButtonClick}
            />
          </div>
        </div>
        <div className="Button_Container">
          <button
            className={`${classes.Resend_Otp_Btn} ${verificationError && verifyButtonClicked ? classes.Resend_Error : ""}`}
            style={{
              background: verifyButtonClicked ? "white" : "white",
            }}
            onClick={handleResendButtonClick}
          >
            Resend
          </button>

          <button className="Verify_Otp_Btn" onClick={handleSubmit}>
            Verify OTP
          </button>
        </div>
      </div>

      {isLoading && (
        <div className={classes.overlay}>
          <div className={classes.loading_text}>Please Wait...</div>
        </div>
      )}
      <ToastContainer />
    </div>
  );
};

export default PurchaseVerifyOtp;
